import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ProgressModeEnum } from '../progress/progress.component';

export interface WizardStepInterface<T> {
  id: T;
  label: string;
  disabled?: boolean;
  completed?: boolean;
  active?: boolean;
  svgIcon?: string;
  next?: T;
  previous?: T;
}

@Component({
  standalone: false,
  selector: 'campus-wizard-progress',
  templateUrl: './wizard-progress.component.html',
  styleUrls: ['./wizard-progress.component.scss'],
})
export class WizardProgressComponent<T> {
  progressModes: typeof ProgressModeEnum = ProgressModeEnum;
  @HostBinding('class.ui-wizard-progress')
  wizardProgressClass = true;

  @Input() steps: WizardStepInterface<T>[];

  @Output() stepClicked = new EventEmitter<WizardStepInterface<T>>();

  clickStep(step: WizardStepInterface<T>) {
    this.stepClicked.emit(step);
  }
}
